module.exports = __webpack_public_path__ + "img/8.49702ff4.svg";